// extracted by mini-css-extract-plugin
export var chip = "_aa-0";
export var filterDropdown = "_aa-5";
export var filterItem = "_aa-6";
export var icon = "_aa-1";
export var removeButton = "_aa-3";
export var removeIcon = "_aa-4";
export var separator = "_aa-2";